import { IJsonSerializable } from "./interfaces"

export class OpExportPluginParam implements IJsonSerializable {

    // Members

    public idDataType: number
    
    public isInputParam: boolean
    public isVisible: boolean

    public defaultValue: any
    public value: any

    // Members End

    
    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false) {
        if (opObj != null) {
            this.idDataType = opObj.IdDataType
            
            this.isInputParam = opObj.IsInputParam
            this.isVisible = opObj.IsVisible

            this.value = opObj.Value
            this.defaultValue = opObj.DefaultValue
        }
    }


    public toJSON(compressed: boolean = false) {
        return {
            IdDataType: this.idDataType,
            
            IsInputParam: this.isInputParam,
            IsVisible: this.isVisible,

            DefaultValue: this.defaultValue,
            Value: this.value
        }
    }

    // IJsonSerializable Implementation End
}